
import Vue from "vue";
import Tasks from "@/components/Tasks.vue"; // @ is an alias to /src
import NewTask from "@/components/NewTask.vue";
import FilterInput from "@/components/filterInput.vue";

export default Vue.extend({
  name: "Home",
  components: {
    Tasks,
    NewTask,
    FilterInput,
  },
});
